import { useState } from "react";

import { DateRange } from "@mui/icons-material";
import { Box, Button, Popover, Stack } from "@mui/material";
import { v4 as uuid } from "uuid";

import OmniDatePicker from "./omniDatePicker";
import OmniResponsiveButton from "./omniResponsiveButton";

const OmniDateRangePopover = props => {
  const { analyticsStartDate, analyticsEndDate, onRangeChange } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [startDate, setStartDate] = useState(analyticsStartDate);

  // eslint-disable-next-line no-unused-vars
  const [endDate, setEndDate] = useState(analyticsEndDate);

  const open = Boolean(anchorEl);
  const id = open ? "date-range-popover" : undefined;

  const handleOpen = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleApply = () => {
    if (startDate && endDate) {
      onRangeChange(startDate, endDate);
      handleClose();
    }
  };

  return (
    <>
      <OmniResponsiveButton
        tooltipTitle="Select Date Range"
        buttonText="Range"
        icon={<DateRange />}
        onClick={handleOpen}
      />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, width: 280 }}>
          <Stack spacing={2}>
            <OmniDatePicker
              label="Start Date"
              disableFuture={true}
              value={startDate}
              name={uuid()} //prevents AutoComplete Suggestions
              variant="inline"
              inputVariant="outlined"
              onAccept={null}
              onChange={date => setStartDate(date)}
              format="MM/dd/yyyy"
              fullWidth
            />
            <OmniDatePicker
              label="End Date"
              value={endDate}
              disableFuture={true}
              name={uuid()} //prevents AutoComplete Suggestions
              variant="inline"
              inputVariant="outlined"
              onAccept={null}
              onChange={date => setEndDate(date)}
              format="MM/dd/yyyy"
              fullWidth
            />
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Button onClick={handleClose}>Cancel</Button>
              <Button variant="contained" onClick={handleApply} disabled={!startDate || !endDate}>
                Apply
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Popover>
    </>
  );
};

export default OmniDateRangePopover;
